const Axios = require("axios");

const h = { "Content-Type": "application/json" };

const get = (url = null, headers = h) => {
  return new Promise((resolve, reject) => {
    Axios.get(url, { headers })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const post = (url = null, data = null, headers = h) => {
  return new Promise((resolve, reject) => {
    Axios.post(url, data, { headers })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const del = (url = null, data = null, headers = h) => {
  return new Promise((resolve, reject) => {
    Axios.delete(url, { data, headers })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const Request = { get, post, del };

module.exports = { Request };
